import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../../user/Errors/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import {HttpNewsBookmarksRepository} from '../Repositories/HttpNewsBookmarksRepository.js'

class GetSavedNewsIdsUseCase extends UseCase {
  #getCurrentUserService
  #repository
  #userNotLoggedInError

  static create({config}) {
    return new GetSavedNewsIdsUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      repository: HttpNewsBookmarksRepository.create({config}),
      userNotLoggedInError: UserErrorsFactory.userNotLoggedInUserError
    })
  }

  constructor({getCurrentUserService, repository, userNotLoggedInError}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
    this.#userNotLoggedInError = userNotLoggedInError
  }

  @tracer({metric: 'GetSavedNewsIdsUseCase#execute'})
  @AsyncInlineError()
  async execute({page = 0, size = 200} = {}) {
    const userEntity = await this.#getCurrentUserService.execute()

    if (!userEntity)
      return Promise.reject(
        this.#userNotLoggedInError({message: '[GetSavedNewsIdsUseCase#execute] User is not logged in'}).toJSON()
      )

    const userId = userEntity.getId()
    const [errorIds, articleIds] = await this.#repository.getSavedIds({userId, page, size})

    if (errorIds) return Promise.reject(errorIds)

    return articleIds
  }
}

export const factory = GetSavedNewsIdsUseCase.create
